module.exports = __webpack_public_path__ + "img/clipboard.4167be96.jpg";